module.exports = __webpack_public_path__ + "img/sm-2022-04-25_20-15-53.a73c5f8f.jpg";